import * as React from "react";

interface IAantalResultatenComponent {
  text: string;
}

export const AantalResultatenComponent = (props: IAantalResultatenComponent): JSX.Element => {
  return <div className="nrOfResults">{props.text}</div>;
};
